import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { TimeHeaderCell } from '../../components/TimeHeaderCell';
/** @hidden */
export var DayViewRowContent = function (props) {
    var slot = props.slot, children = props.children;
    return (React.createElement(React.Fragment, null,
        props.isMaster
            ? React.createElement(TimeHeaderCell, { as: props.timeHeaderCell, date: slot.zonedStart, start: slot.zonedStart, end: slot.zonedEnd, className: classNames('k-side-cell', {
                    'k-major-cell': !props.isLast
                }) })
            : React.createElement("div", { className: 'k-scheduler-cell k-heading-cell k-side-cell' }),
        children));
};
//# sourceMappingURL=DayViewRowContent.js.map